module.exports = __webpack_public_path__ + "img/07.61eaca35.jpg";